var map = {
	"./en/btn_99_2.png": "mTVw",
	"./es/btn_99_2.png": "c+aD",
	"./pt/btn_99_2.png": "VN4O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yMIP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_99_2\.png$
// module id = yMIP
// module chunks = 0